/* eslint-disable */

import React,{Component} from 'react';
import SendDropdown from './sendDropdown';
import Header from '../Headers';
import url from '../../config/url';

// import Tables from '../Tables';
import SendoutTable from './sendOutTable';
import axios from 'axios';
import callMe from '../callApi';
import Singleton from '../../sock';
import  generateBatch  from '../../CommonFunc';
import DisplayError from '../../DisplayError';
import fetchBookNo from '../fetchCode';
import LoaderComponent from '../cAjaxLoader';
import { ToastContainer } from 'react-toastr';
import DownloadCsvs from './downloadCsv_';

const fileHeaders = [
    {
        label: 'Book Number', key: 'bookNumber'
    },
    {
        label: 'Message', key: 'message'
    }
];
// var url = ""
var tableBody = [];
var books = [];
var batchTypeID = 0;
var bookno = [];
var branchSelected = {};


const myStyle = {
    marginTop:30,
    rows: 10,
}
Array.prototype.contains = function(v) {
    for(var i = 0; i < this.length; i++) {
        if(this[i] === v) return true;
    }
    return false;
};

Array.prototype.unique = function() {
    var arr = [];
    for(var i = 0; i < this.length; i++) {
        if(!arr.includes(this[i])) {
            arr.push(this[i]);
        }
    }
    return arr; 
}
const theaders = ['Book Number','Message'] ;
const mHeaders = ['number','message'];//edit it according to json data

class SendOut extends Component{
    constructor(props){
        super(props);
        this.state = {
            batchNumber:0,
            bookno:'',
            reset:false,
            errorDesc:'',
            errorVisible:false,
            startListening:false,
            tData:{},
            resetTableBody:false,
            showLoader:false,
            shouldUpdate:false, //new
            context:'',
            newOrigBranch:''
        }
        this.handleGenerateClick = this.handleGenerateClick.bind(this);
        this.handleStart = this.handleStart.bind(this);
        this.handleSend = this.handleSend.bind(this);
        this.handleClear = this.handleClear.bind(this);
        // sessionStorage.setItem('hi','hi');
    }

    componentWillMount(){
        // console.log('sendout will mount connection will begin');
        
        this.sock = Singleton.getInstance();
        console.log(this.sock);
    }

    componentDidMount(){
        // console.log('sendout did mount, receive msg here');
        this.sock.onmessage = msg =>{
            //for java
            if(typeof(msg.data) === 'string'){
                this.fetchCode(msg.data);
            }
            else{
                FileReader.prototype.that = this;
                var reader = new FileReader();
                reader.onload = function() {
                    reader.__proto__.that.fetchCode(reader.result)
                }
                reader.readAsText(msg.data)
           }
        };

        this.sock.onerror = (err) => {
            console.log(err);
            this.refs.container.error("Could not connect to kiosk. Please check your connection and refresh");
            // this.setState({
            //     errorVisible:true,
            //     errorDesc:"Could not connect to kiosk. Please check your connection and refresh"
            // })  
        }

        this.sock.onclose = (evt) =>{
            console.log(evt);
        }
        
    }
    componentWillUnmount(){
        bookno=[];
        // console.log('sendout unmount connection will be closed now');
        Singleton.closeSocket(this.sock);
        
    }

    /******************* Calling generate batch api ************************* */

    handleGenerateClick(e){
        // console.log("generate cliclk "+ batchTypeID);
        generateBatch(batchTypeID).then(res => {
            if(res.error){
                this.refs.container.error(res.errorDesc);
                // this.setState({errorVisible:true, errorDesc:res.errorDesc})
            }
            else{
                this.setState({batchNumber:res.batchNumber})
            }
        }).catch(err => {console.log(err)})
    }

    /************** start fetching bookno from kiosk *********** */
    handleStart(){
        console.log(this.state.startListening);

        this.setState({startListening:true});
    }

    handleClear(){
        bookno = [];
        this.setState({tData:{},resetTableBody:true,reset:true});
    }

    //************* proccessBatchapi (Sendout api) ****************8 */

    handleSend(){
        this.setState({showLoader:true})
        
        var booksCSV = "";
        var uniqueBooks = bookno.unique();  //bookno array is populated in fetchCode method
        var dataToPostForSorting = [];
        for(let i =0 ; i<uniqueBooks.length ; i++){
            booksCSV += uniqueBooks[i]+',';
        }
        var createdAt = sessionStorage.getItem('at');
        var createdBy = sessionStorage.getItem('by');
        
        if(this.state.context === "swap"){
            console.log(this.state.newOrigBranch.value)
            let booksArr = booksCSV.split(',');
            for(let i = 0; i<booksArr.length;i++){
                if(booksArr[i] !== ""){
                    dataToPostForSorting.push({
                        "bookNumber":booksArr[i],
                        "origBranchId":branchSelected.value,
                        "newOrigBranch":this.state.newOrigBranch.value,
                        "createdBy":createdBy,
                        "createdAt":createdAt
                    })
                }
            }
            axios.post(
                url + 'swapBook',
                dataToPostForSorting
            ).then(response =>
                {
                    this.setState({showLoader:false})
    
                    if(response.data.status)
                    {
                        var tableData = [];
                        var data = response.data.successObject;
                        for(let i = 0 ; i < data.length; i++){
                            if(data[i].status){
                                tableData.push({
                                    number:data[i].bookNumber,
                                    message:data[i].successMsg
                                });
                            }else{
                                tableData.push({
                                    number:data[i].bookNumber,
                                    message:data[i].errorMsg
                                });
                            }
                        
                            this.setState(prevState => ({
                                tData:tableData,
                                resetTableBody: !prevState.resetTableBody
                            }));
                        
                        }
                    }
                    else{
                        this.refs.container.error(response.data.errorDescription)
                    }
                    console.log(response);
                    return;

                }).catch(err=>{
                    console.log(err);
                    this.setState({showLoader:false})
                    return;

                });
    
        }else if(this.state.context == "sellOff"){
            console.log(this.state.newOrigBranch.value)
            let booksArr = booksCSV.split(',');
            for(let i = 0; i<booksArr.length;i++){
                if(booksArr[i] !== ""){
                    dataToPostForSorting.push({
                        "bookNumber":booksArr[i],
                        "origBranchId":branchSelected.value,
                        "createdBy":createdBy,
                        "createdAt":createdAt
                    })
                }
            }
            axios.post(
                url + 'sellOffBook',
                dataToPostForSorting
            ).then(response =>
                {
                    this.setState({showLoader:false})
    
                    if(response.data.status)
                    {
                        var tableData = [];
                        var data = response.data.successObject;
                        for(let i = 0 ; i < data.length; i++){
                            if(data[i].status){
                                tableData.push({
                                    number:data[i].bookNumber,
                                    message:data[i].successMsg
                                });
                            }else{
                                tableData.push({
                                    number:data[i].bookNumber,
                                    message:data[i].errorMsg
                                });
                            }
                        
                            this.setState(prevState => ({
                                tData:tableData,
                                resetTableBody: !prevState.resetTableBody
                            }));
                        
                        }
                    }
                    else{
                        this.refs.container.error(response.data.errorDescription)
                    }
                    console.log(response);
                    return;

                }).catch(err=>{
                    console.log(err);
                    this.setState({showLoader:false})
                    return;

                });
        }
        else{
            axios.post(
                url + 'sendoutKiosk',
                {
                    createdAt:createdAt,
                    createdBy:createdBy,
                    booksCSV:booksCSV,
                    // ibtBatchId:batchTypeID,
                    ibtBatchId:this.state.batchNumber,
                    sendBranchId:branchSelected.value
                }
            ).then(response =>
                {
                    this.setState({showLoader:false})
    
                    if(response.data.status)
                    {
                        var tableData = [];
                        var data = response.data.successObject;
                        for(let i = 0 ; i < data.length; i++){
                            if(data[i].origLocationBranchId == createdAt){
                                tableData.push({
                                    number:data[i].bookNo,
                                    message:'Book Sent Out Successfully'
                                });
                            }else{
                                tableData.push({
                                    number:data[i].bookNo,
                                    message:'Success'
                                });
                            }
                        
                            this.setState(prevState => ({
                                tData:tableData,
                                resetTableBody: !prevState.resetTableBody
                            }));
                        
                        }
                }
                    else{
                        this.refs.container.error(response.data.errorDescription)
                    // this.setState({errorVisible:true, errorDesc:response.data.errorDescription,showLoader:false})
                        
                    }
                    console.log(response);
                }).catch(err=>{
                    console.log(err);
                    this.setState({showLoader:false})
                });
    
        }   
        
        // axios.post(
        //     url + 'processBatch',
        //     {
        //         createdAt:sessionStorage.getItem('at'),
        //         createdBy:sessionStorage.getItem('by'),//5
        //         booksCSV:booksCSV,
        //         ibtBatchId:batchTypeID,
        //         sendBranchId:branchSelected.value
        //     })
        //     .then(response =>
        //     {
        //         this.setState({showLoader:false})

        //         if(response.data.status)
        //         {
        //             var tableData = [];
        //             for(let i = 0 ; i < uniqueBooks.length; i++){
        //                 tableData.push({
        //                     number:uniqueBooks[i],
        //                     message:response.data.successObject
        //                 });
        //             }
        //             this.setState(prevState => ({
        //                 tData:tableData,
        //                 resetTableBody: !prevState.resetTableBody
        //             }));
                    
        //         }
        //         else{
        //             this.refs.container.error(response.data.errorDescription)
        //         // this.setState({errorVisible:true, errorDesc:response.data.errorDescription,showLoader:false})
                    
        //         }
        //         console.log(response);
        //     }).catch(err=>{
        //         console.log(err);
        //         this.setState({showLoader:false})
        //     });
    }
    
    

    /*************** getting ibtbatchtype from dropdown api ***************** */

    getBatchType(batchTypeId){
        // console.log("getbatch tyoe "+batchTypeId);
        batchTypeID = batchTypeId; //this will be used to call generateBatchNumber api
        // console.log("getbatch tyoe "+batchTypeID);
    
    }

    getDropdownOnChangeData(value,context){
        branchSelected = {}
        branchSelected = value;
        this.setState({context:context})

    }

    getNewDDChangeData(value,context){
        // console.log(value)
        this.setState({context:context,newOrigBranch:value})
    }

    //calling the sort api 
    fetchCode(value)
    {
        if(this.state.startListening)
        {
            if(books.includes(value)){
                return;
            }
            books.push(value)
            var obj = {
                value:value,
                bookno:bookno,
                start:this.state.startListening,
                callingFrom:"sendout"
            };
            fetchBookNo(obj).then(res => {
                console.log(res);
                if(res.error){
                    this.refs.container.error(res.data)
                }
                else{
                    this.setState({tData:res.data})
                }
                bookno = res.bookno;
            }).catch(err => {
                console.log(err);
                this.refs.container.error('Something Went Wrong!!')
                return;
            });
            
        }
        // if(this.state.startListening){
        //     console.log('fetchcode of sendout called');
        //     if(bookno.includes(value)){
        //         console.log('match');
        //         console.log(bookno);    
        //         return;
        //     }
        //     else{
        //         console.log('no match');
        //         bookno.push(value);    
        //         var callingFrom = 'sendout';
        //         console.log('calling sort api against book no '+value);  
        //         callMe(value, callingFrom).then(tableData =>{
                    
        //             if(Object.keys(tableData).length > 0 && tableData.success === true){
        //                 this.setState({
        //                     tData:tableData,
        //                     errorVisible:false
        //                 });
        //             }
        //             else{
        //                 if(!tableData.success){
        //                     bookno.pop(value);
        //                     this.setState({errorVisible:true,errorDesc:tableData.errorDesc})
                            
        //                 }
        //             }
        //         })
        //         .catch(err =>{
        //             console.log(err);
        //         });
        //     }
        // }

    }

    
    // fetchTableBody(tb,shouldResetBookNo){
    //     console.log('receiving table body inside sendout');
    //     console.log(tb);
    //     tableBody = tb;
    //     for(let i = 0 ; i<tableBody.length; i++){
    //         books.push(tableBody[i].key); //fetching the book number from key
    //     }
    //     console.log(books);
    // }


    render(){
        return(
            <React.Fragment>
                <LoaderComponent showLoader = {this.state.showLoader}>
                <ToastContainer 
                    ref = "container"    
                    className="toast-top-right"
                />
                <Header hname = "Sending Out"/>

                <DisplayError 
                    errorVisible = {this.state.errorVisible}
                    errorDesc = {this.state.errorDesc}
                />
                
                <SendDropdown 
                    callback = {this.getDropdownOnChangeData.bind(this) } 
                    getBatchType = {this.getBatchType.bind(this)}    
                    mystyle = {myStyle}
                    callback2 = {this.getNewDDChangeData.bind(this)}
                />    
                
                <div className = "row">
                    <div className="col-lg-4" style = {{margin: 30}}>
                
                        <button className = "btn" 
                            onClick = {this.handleGenerateClick}>Generate</button>
                
                        <input type="text" readOnly 
                        style = {{marginLeft:10,width:50}} value={this.state.batchNumber}/>
                        
                        <input type="text" readOnly
                         style = {{marginLeft:5,width:40}} value={this.state.batchNumber}/>

                    </div>

                    <div className = "col-lg-2"></div>
                    
                    {/* //style = {{margin: 30}} */}
                    
                    <div style = {{margin: 10}} className = "col-sm-6 btngroup btn-toolbar">
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleStart} >Start</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleSend}   >Send</button>
                        <button style = {{marginRight:10}}className = "btn" onClick = {this.handleClear} >Clear</button>
                    </div> 
                    
                </div>

                <div className="row">
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4"></div>
                    <div className="col-sm-4 pull-right">
                        <DownloadCsvs
                            headers={fileHeaders}
                            onclickCb={this.onclickCb}
                            tableId = {"myTable"}
                            keys = {["bookNumber","message"]}
                            filename = {`${this.state.context}_${new Date().getDate()}-${new Date().getMonth()}.csv`}
                        />
                    </div>
                </div>
                <div className = "row" style = {{marginTop:10}}>
                    <div className = "col-lg-12">
                        <SendoutTable 
                            mHeaders = {mHeaders} 
                            displayCount = {this.input} 
                           // fetchTableBody = {this.fetchTableBody.bind(this)}
                            headers = {theaders} 
                            body = {this.state.tData}
                            resetTable = {this.state.resetTableBody} 
                            //shouldUpdate = {this.state.shouldUpdate}
                        />
                    </div>  
                
                </div>
                </LoaderComponent>
            </React.Fragment>
        )
    }
}

export default SendOut;


// WEBPACK FOOTER //
// ./src/Components/Sending-Out/SendOut.js